import { render, staticRenderFns } from "./MainSearch.vue?vue&type=template&id=be7ad67a&scoped=true&lang=html&"
import script from "./MainSearch.vue?vue&type=script&lang=js&"
export * from "./MainSearch.vue?vue&type=script&lang=js&"
import style0 from "./MainSearch.vue?vue&type=style&index=0&id=be7ad67a&prod&lang=scss&scoped=true&"
import style1 from "./MainSearch.vue?vue&type=style&index=1&id=be7ad67a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be7ad67a",
  null
  
)

export default component.exports